import Analytics from '../../../../../analytics';
import { getAPWindow } from '../../../helpers/utils';
import DateUtil from '../../../../common/utils/dateUtil';

export const faOnFromCityFocus = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: 'select_fromCity',
  });
};
export const faOnFromCitySelect = ({ city, cityType, sectionName }) => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.VALUE_SELECTED,
    event_value: `edit_fromCity|${city} ${cityType || ''}|${sectionName}`,
  });
};

export const faOnFromCityOnNext = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.SYSTEM_GENERATED,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: 'select_dest',
  });
};

export const faOnDestCityFocus = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: 'select_dest',
  });
};

export const faOnDestCitySelect = ({ city, cityType, sectionName }) => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.VALUE_SELECTED,
    event_value: `edit_dest|${city} ${cityType || ''}|${sectionName}`,
  });
};

export const faOnDestCityOnNext = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.SYSTEM_GENERATED,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: 'select_dest',
  });
};

export const faOnDateFocus = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: 'select_date',
  });
};

export const faOnDateSelect = ({ date }) => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.VALUE_SELECTED,
    event_value: `select_date|${DateUtil.formatDate(date)}|${getAPWindow(date)}`,
  });
};

export const faOnPaxFocus = () => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_value: 'select_roomsAndGuests',
  });
};

export const faOnPaxSelect = value => {
  Analytics.captureEvent({
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_name: Analytics.EVENT_NAMES.VALUE_SELECTED,
    event_value: `edit_roomsAndGuests|${value}`,
  });
};

export const faOnSearchApply = ({ fromCity, destCity, date, pax }) => {
  Analytics.captureEvent(
    {
      event_type: Analytics.EVENT_TYPES.USER_ACTION,
      event_name: Analytics.EVENT_NAMES.SEARCH_CLICKED,
      event_value: `search|${fromCity}|${destCity}|${DateUtil.formatDate(date)}|${pax}`,
    },
    true
  );
};

export const faOnExploreClick = showMenu => {
  Analytics.captureEvent({
    event_name: Analytics.EVENT_NAMES.BUTTON_CLICK,
    event_type: Analytics.EVENT_TYPES.USER_ACTION,
    event_value: showMenu ? 'Menu_Collapse' : 'Menu_Expand',
  });
};
